<div class="d-flex flex-column border-bottom">
    <div class="d-flex flex-column p-2 gap-3">
        
        <div class="d-flex flex-column">
            <div class="d-flex flex-row gap-1">
                <div class="flex-grow-1 d-flex flex-row align-items-center gap-1">
                    @let processIcon = moduleConfig()?.icon ?? processRunnerIcon();
                    @if(processIcon){
                        <fa-icon class="color--text-primary-30 font-size-09rm" [icon]="['fas', processIcon]" [tooltip]="moduleConfig()?.name" [tooltip-placement]="'top'"/>
                    }
                    @if (processConfig()?.name) {
                        <span class="text-single-line font-semibold">{{processConfig()?.name}}</span>
                    }
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center clickable" (click)="closeProcess()" [tooltip]="'Close Process'">
                    @if (processStatus() == 'Completed' || processStatus() == 'WithErrors') {
                        <fa-icon [icon]="['fas', 'xmark']"/>
                    }
                </div>
            </div>

            @if(tenantCompany()){
                <div style="line-height: 0.8rem;">
                    <span class="font-size-08rm color--text-primary-50 font-light">{{tenantCompany()?.fullName}}</span>
                </div>
            }
        </div>

        <div class="d-flex flex-row gap-1">
            <div class="d-flex flex-column justify-content-center align-items-center position-relative" style="width:24px; height:24px;">
                <span class="position-absolute flex-grow-1 top-0 bottom-0 left-0 right-0 d-flex justify-content-center align-items-center">
                    @if (processStatus() == 'Pending' || processStatus() == 'Started' || processStatus() == 'Requested') {
                        <app-loading-spinner class="flex-grow-1 p-1"/>
                    }
                    @else if(processStatus() == 'Completed'){
                        <fa-icon class="color--green-500-70" [icon]="['far', 'circle-check']"/>
                    }
                    @else if(processStatus() == 'WithErrors'){
                        <fa-icon class="color--red-500-70" [icon]="['far', 'circle-xmark']"/>
                    }
                </span>
            </div>
            
            @if (processMessage()) {
                <span class="font-light font-size-09rm">{{processMessage()}}</span>
            }

            @if(hasErrorLog() || hasExternalLink()){
                <span class="font-light">-</span>
                <div class="col d-flex flex-row gap-1">
                    <fa-icon class="color--text-primary-70" [icon]="['fad', 'file']"/>
                    <span class="text-link text-decoration-underline font-size-09rm">
                        @if (hasErrorLog()){
                            <span (click)="openErrorLog()">View Error Log</span>
                        }
                        @else if (hasExternalLink()){
                            <span (click)="openExternalURLFile()">View Report</span>
                        }
                    </span>
                </div>
            }

        </div>
    </div>
    <!-- @if (_options.progressBar) {
        <div>
            <div class="toast-progress" [style.width]="width() + '%'"></div>
        </div>
    } -->
</div>